import React from 'react'

import Spinner from '@divvy-web/skylab.spinner'

interface FallbackSpinnerProps {
  fullPage?: boolean
  centered?: boolean
}

const FallbackSpinner = ({ fullPage, centered }: FallbackSpinnerProps) => {
  return (
    <div>
      <Spinner
        centered={centered}
        fullPage={fullPage}
      />
    </div>
  )
}

export default FallbackSpinner
